import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Notification from './Notification'
import ActivityLoader from 'react-loaders'

import './NotificationsPopover.scss'

const displayNotifications = (notifications, navigateFromNotification, t) => {
  if (notifications && notifications.length > 0) {
    return notifications.map(notification => (
      <Notification
        notification={notification}
        navigateFromNotification={navigateFromNotification}
        key={notification.id}
      />
    ))
  }
  return (
    <p className='notifications-empty-text'>
      {t('common.notifications.emptyText')}
    </p>
  )
}

const NotificationPopover = ({
  notifications,
  refreshNotifications,
  clearNotifications,
  loader,
  navigateFromNotification,
}) => {
  const { t } = useTranslation()

  return (
    <div id='NotificationsContainer'>
      {loader ? (
        <div className='p-4 animated fadeIn'>
          <ActivityLoader className='notifications-loader' type='ball-pulse' color={'lightgrey'} />
        </div>
      ) : (
        <div className='notifications-wrapper'>
          <div className='notifications-button-container'>
            {notifications && notifications.length > 0 && (
              <button
                className='btn btn-link notifications-clear-btn'
                onClick={clearNotifications}
              >
                {t('common.notifications.clearNotifications')}
              </button>
            )}
            <button
              className='btn btn-link notifications-refresh-btn'
              onClick={refreshNotifications}
            >
              <i className='fa fa-refresh' />
            </button>
          </div>
          {displayNotifications(notifications, navigateFromNotification, t)}
        </div>
      )}
    </div>
  )
}

NotificationPopover.propTypes = {
  notifications: PropTypes.array,
  refreshNotifications: PropTypes.func,
  clearNotifications: PropTypes.func,
  loader: PropTypes.bool,
  navigateFromNotification: PropTypes.func,
}

export default NotificationPopover
